export interface StockItem {
  id: string;
  pta_id: string;
  item_name: string;
  supplier: string | null;
  unit_type: string | null;
  low_stock_threshold: number;
  created_at: string;
  updated_at: string;
}

export interface StockBatch {
  id: string;
  stock_item_id: string;
  pta_id: string;
  batch_number: string | null;
  quantity: number;
  expiry_date: string | null;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface StockItemWithBatches extends StockItem {
  batches: StockBatch[];
  totalQuantity: number;
}

export interface CateringMenuItem {
  id: string;
  name: string;
  price: number;
  allergens: string[];
  icon: string | null;
  color: string;
  category: string | null;
}

export interface Event {
  id: string;
  name: string;
  event_date: string;
}

export interface EventAssignment {
  id: string;
  event_id: string;
  event_name: string;
  event_date: string;
  items: { 
    id: string;
    name: string; 
    quantity: number;
    stock_item_id?: string;
    menu_item_id?: string;
  }[];
}

export interface CustomSupplier {
  id: string;
  name: string;
}

export interface CustomCategory {
  id: string;
  category_name: string;
}

export interface ReturnItem {
  assignmentId: string;
  stockItemId: string;
  itemName: string;
  assignedQuantity: number;
  returnQuantity: number;
}

export const DEFAULT_SUPPLIERS = ["Bookers", "Amazon"];
export const DEFAULT_CATEGORIES = ["Drinks", "Food"];
export const UNIT_TYPES = ["units", "boxes", "packets", "kg", "grams", "crates"];

export interface StockLogEntry {
  id: string;
  pta_id: string;
  user_id: string | null;
  user_name: string | null;
  action_type: string;
  item_name: string;
  batch_number: string | null;
  quantity: number | null;
  event_name: string | null;
  details: string | null;
  created_at: string;
}

export const allergenTooltips: Record<string, string> = {
  V: "Vegetarian - Suitable for vegetarians",
  VE: "Vegan - Contains no animal products",
  GF: "Gluten Free - Contains no gluten",
  DF: "Dairy Free - Contains no dairy products"
};
